import { useRef } from 'react';
// This exists so we can mock it in tests and inject refs by name
export function useNamedRef(name, initialValue) {
    return useRef(initialValue);
}
